export default "https://cdn-static.gokick.com/assets/3bfc31eca91a3170017daa7173a338c2b0e2dfbc/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";